export const getQmsDocumentLabel = (qd, qdTypes) => {
  const qdType = (qdTypes || []).find(
    (qdt) => qdt.qmsDocumentTypeId === qd.qmsDocumentTypeId
  );
  const separator = qdType ? qdType.separator : " ";

  return `${qdType.label} ${qd.number}${separator}${qd.title}`;
};

export const mapTeamMemberRoleToUserRole = (memberRole, isQmt) => {
  switch (memberRole) {
    case 1: // Member
    case 2: // Vice Chair
    case 3: // Chair
      return isQmt ? 2 : 1; // 2: QMR_AUTHORITY, 1: QMS_USER
    case 4: // Management Sponsor
      return 4; // 4: TOP_MANAGEMENT
  }
};
